import { notifications } from '@mantine/notifications';
import { IconMoodPuzzled } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { isNetworkError } from '@xver/libs/connectionNotifier';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../../../../apis';

export function useLaunchOptionQuery() {
    const { t } = useTranslation('notifications');
    const hasShownError = useRef(false);

    const { data, isPending, error } = useQuery({
        queryKey: ['api.v1.launch.options.get'],
        queryFn: async () => Endpoints.v1.Instances.getLaunchOptions(),
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    });

    useEffect(() => {
        if (error && !isNetworkError(error) && !hasShownError.current) {
            hasShownError.current = true;
            notifications.show({
                title: t('query.failed'),
                message: t('query.launchOptionsFailedMessage'),
                icon: <IconMoodPuzzled size={32} color={'#eb5757'} />,
            });
        }

        if (!error) {
            hasShownError.current = false;
        }
    }, [error, t]);

    return {
        data,
        isPending,
    };
}
